import type { CMSConfig } from '#types/config/components/cms'

export default {
  defaultLocale: 'en_US',
  locales: { FR: 'fr_CA' },
  url: 'https://widgets.olapic-cdn.com'
} satisfies CMSConfig['ugc']['olapic']
